import { useSearchParams } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { QuoteForm } from "@/components/site/QuoteForm";

export default function Quote() {
  const [params] = useSearchParams();
  return (
    <>
      <Seo title="Request a quote" description="Request an export quote for G9 banana, red onion or Bhagwa pomegranate. FOB or CIF, by the container." path="/request-quote" />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4 space-y-4">
          <p className="text-xs uppercase tracking-[0.25em] text-emerald-800">Request a quote</p>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight">Tell us what you need.</h1>
          <p className="text-stone-600">We reply with a call to confirm details, then send a written quote. Prices are never published on the site.</p>
        </div>
        <div className="md:col-span-8 rounded-lg border border-stone-200 bg-white p-6 md:p-10">
          <QuoteForm defaultProduct={params.get("product") || ""} />
        </div>
      </section>
    </>
  );
}
